<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <PageHeader :title="title" :items="items"/>
              <b-card>
                <form>
                  <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-3">
                      <label class="col-form-label col-form-label-sm" for="training_trade_id">Training Trade</label>
                      <select v-model="search_data.training_trade_id"
                              id="training_trade_id" class="form-control form-control-sm" name="training_trade_id">
                        <option :value="''" selected>Select Training Trade</option>
                        <option v-for="(trade, index) in trades" :key="index" v-bind:value="trade.id">{{ trade.id }} : {{ trade.training_trade_desc }}</option>
                      </select>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                      <label class="col-form-label col-form-label-sm" for="training_venue_id">Training Venue</label>
                      <select v-model="search_data.training_venue_id"
                              id="training_venue_id" class="form-control form-control-sm" name="training_trade_id">
                        <option :value="''" selected>Select Training Venue</option>
                        <option v-for="(venue, index) in venues" :key="index" v-bind:value="venue.id">{{ venue.id }} : {{ venue.training_venue_desc }}</option>
                      </select>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                      <label class="col-form-label col-form-label-sm" for="district_id">District</label>
                      <select v-model="search_data.district_id" id="district_id" name="district_id" class="form-control form-control-sm">
                        <option :value="''">Select District</option>
                        <option v-for="(district, index) in districts" :key="index" :value="district.id">{{ district.id }}: {{ district.district_desc }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-3">
                      <button class="btn btn-success btn-sm mt-3" @click.prevent="search">Search</button>
                    </div>
                  </div>
                </form>
              </b-card>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                      <div v-if="batches.length > 0" class="row mb-2">
                        <div class="col-md-12">
                          <span class="badge badge-success">Total Search Data Found: {{ batches.length }}</span>
                          <button type="button" id="export-table" @click="onexport"  class="btn btn-success float-right">Download Excel</button>
                        </div>
                      </div>
                        <div class="table-responsive mb-0" style="overflow-x: auto">
                            <table class="table table-centered table-striped"  id="titledExcel">
                                <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Rep Name</th>
                                    <th>Rep Father`s Name</th>
                                    <th>Mouza</th>
                                    <th>Training Trade</th>
                                    <th>Venue</th>
                                    <th>Batch No</th>
                                    <th>Duration</th>
                                    <th>Total Attendance</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(batch, index) in batches" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ batch.trainee.rep_name ? batch.trainee.rep_name : batch.trainee.ses.name }}</td>
                                    <td>{{ batch.trainee.rep_father_husband_name ? batch.trainee.rep_father_husband_name : batch.trainee.ses.father_husband_name }}</td>
                                    <td>{{ batch.trainee.ses.mouza.mouza_desc }}</td>
                                    <td>{{ batch.trade ? batch.trade.training_trade_desc : ''}}</td>
                                    <td>{{ batch.venue ? batch.venue.training_venue_desc : '' }}</td>
                                    <td>{{ batch.batch_no ? batch.batch_no.batch_no_desc : '' }}</td>
                                    <td>{{ batch.duration }}</td>
                                    <td>{{ batch.total_attendance }}</td>
                                    <td>{{ batch.start_date }}</td>
                                    <td>{{ batch.end_date }}</td>
                                </tr>
                                </tbody>
                            </table>

                            <div v-if="loader" class="loader">Loading...</div>
                            <h5 class="text-center text-secondary" v-if="batches.length === 0 || !flag">
                              No Data Found
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import http from "@state/http";
    import XLSX from 'xlsx';


    export default {
        page: {
            title: 'Batch',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: 'Search Batch',
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Batch',
                        href: '/batch/list',
                    },
                    {
                        text: 'List',
                        active: true,
                    },
                ],
                batches: {},
                trades: [],
                venues: [],
                districts: [],
                batch_nos: [],
                search_data: {
                    training_trade_id: '',
                    district_id: '',
                    training_venue_id: '',
                },
              flag: false,
              loader: false,
                batch: {}
            }
        },

        mounted() {
            this.getBatchCodes();
        },
        methods: {
            getBatchCodes() {
                http.get("api/batch/codes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.trades = data.trades;
                        this.venues = data.venues;
                        this.districts = data.districts;
                        this.batch_nos = data.batch_nos;
                    }
                });
            },
            search() {
                this.flag = true
                this.loader = true
                http.post("api/batch/trainee/search/view/list", this.search_data).then(response => {
                    if (!response.error) {
                        this.flag = true;
                        this.loader = false
                        this.batches = response.data.batches;
                    }
                });
            },
          onexport(evt) {
            var tbl = document.getElementById('titledExcel');
            var wb = XLSX.utils.table_to_book(tbl);
            XLSX.writeFile(wb, "batch.xlsx");
          }
        },
    }
</script>

